class Logger {
    /* tslint:disable:no-console */
    public error(message: string) {
        console.error(message);
    }
}

export default new Logger();
